export default "__VITE_ASSET__DJZ6rtCF__"